export default __webpack_public_path__ + "static/media/ANF.1ca372bb.svg";